export default class DataSetColDateEditor
{
	name;
    label;
    visible = true;
    helpText = null;
    displayLength = 12;
    alignment = "Center";
    displayFormat = "yyyy-MM-dd";
    type = "Date";
}


// WEBPACK FOOTER //
// ./src/universalView/dataSet/DataSetColDateEditor.js